import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const TermsAndConditions = () => {
    const theme = useTheme();

    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <Paper sx={{ p: 4, borderRadius: 2 }}>
                <Typography variant="h4" component="h1" gutterBottom sx={{ color: theme.palette.blue[900], fontWeight: 600 }}>
                    Terms and Conditions
                </Typography>

                <Typography variant="subtitle1" sx={{ mb: 4, color: theme.palette.grey[600] }}>
                    Last Updated: January 31, 2025
                </Typography>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    <section>
                        <Typography variant="h6" gutterBottom sx={{ color: theme.palette.blue[800] }}>
                            1. Agreement to Terms
                        </Typography>
                        <Typography paragraph>
                            By accessing and using apply-bridge ("the Service"), you agree to be bound by these Terms and Conditions. If you disagree with any part of these terms, you do not have permission to access the Service.
                        </Typography>
                    </section>

                    <section>
                        <Typography variant="h6" gutterBottom sx={{ color: theme.palette.blue[800] }}>
                            2. Description of Service
                        </Typography>
                        <Typography paragraph>
                            apply-bridge is an automated job application management system that helps users compose, send, and track job application emails. The Service includes email automation, follow-up management, and application tracking features.
                        </Typography>
                    </section>

                    <section>
                        <Typography variant="h6" gutterBottom sx={{ color: theme.palette.blue[800] }}>
                            3. User Accounts and Security
                        </Typography>
                        <Typography paragraph>
                            You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You must immediately notify apply-bridge of any unauthorized use of your account or any other security breach.
                        </Typography>
                    </section>

                    <section>
                        <Typography variant="h6" gutterBottom sx={{ color: theme.palette.blue[800] }}>
                            4. Limitation of Liability
                        </Typography>
                        <Typography paragraph>
                            apply-bridge implements reasonable security measures to protect user data but cannot guarantee absolute security. We are not liable for:
                        </Typography>
                        <ul>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Any unauthorized access to user information resulting from hacking, malware, or other security breaches beyond our reasonable control
                            </Typography>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Data breaches caused by third-party service providers
                            </Typography>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Loss or exposure of information due to user error or compromised user credentials
                            </Typography>
                            <Typography component="li" sx={{ ml: 4 }}>
                                Any consequential losses or damages arising from the use of our Service
                            </Typography>
                        </ul>
                    </section>

                    <section>
                        <Typography variant="h6" gutterBottom sx={{ color: theme.palette.blue[800] }}>
                            5. Third-Party Services
                        </Typography>
                        <Typography paragraph>
                            Our Service integrates with third-party services including Gmail, Outlook, and AI providers. While we carefully select our service providers, we are not responsible for their actions or policies. Users are encouraged to review the terms and privacy policies of these third-party services.
                        </Typography>
                    </section>

                    <section>
                        <Typography variant="h6" gutterBottom sx={{ color: theme.palette.blue[800] }}>
                            6. User Content
                        </Typography>
                        <Typography paragraph>
                            You retain all rights to the content you submit through our Service, including resumes and email content. However, you grant apply-bridge a license to use, store, and process this content to provide our Services.
                        </Typography>
                    </section>

                    <section>
                        <Typography variant="h6" gutterBottom sx={{ color: theme.palette.blue[800] }}>
                            7. Modifications to Service
                        </Typography>
                        <Typography paragraph>
                            apply-bridge reserves the right to modify or discontinue the Service at any time, with or without notice. We are not liable to you or any third party for any modification, suspension, or discontinuance of the Service.
                        </Typography>
                    </section>

                    <section>
                        <Typography variant="h6" gutterBottom sx={{ color: theme.palette.blue[800] }}>
                            8. Governing Law
                        </Typography>
                        <Typography paragraph>
                            These Terms shall be governed by and construed in accordance with the laws of INDIA, without regard to its conflict of law provisions.
                        </Typography>
                    </section>

                    <section>
                        <Typography variant="h6" gutterBottom sx={{ color: theme.palette.blue[800] }}>
                            9. Contact Information
                        </Typography>
                        <Typography paragraph>
                            For any questions about these Terms, please contact us at info@apply-bridge.com.
                        </Typography>
                    </section>
                    <Box sx={{ mt: 4 }}>
                        <Typography variant="h6" gutterBottom sx={{ color: theme.palette.blue[800], fontWeight: 600 }}>
                            Contact Information
                        </Typography>
                        <Typography>BIZZENCE WEBTECH PRIVATE LIMITED</Typography>
                        <Typography>Fl No203 Akshar DivyaApt, Aagar Takli Upnagar</Typography>
                        <Typography>Nashik Road, Nashik, Maharashtra 422101</Typography>
                        <Typography>India</Typography>
                        <Typography>Phone: (+91)7972305727</Typography>
                        <Typography>Email: info@apply-bridge.com</Typography>
                    </Box>
                </Box>
            </Paper>
        </Container>
    );
};

export default TermsAndConditions;